import React, { FC, HTMLAttributes, memo } from "react";

const TableBody: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return <div {...props}>{children}</div>;
};

export default memo(TableBody);
